import React from 'react';

// --- Wrapper for budget steps 2, 3, and 4 ---
const BudgetStepWrapper = ({ title, description, children, onNext, onPrev }) => (
  <div className="animate-fade-in space-y-4">
    <h2 className="text-2xl font-bold text-gray-800">{title}</h2>
    <p className="text-gray-600">{description}</p>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-4">
      {children}
    </div>
    <div className="flex justify-between pt-4">
      <button onClick={onPrev} className="text-gray-700 font-medium py-2 px-4 rounded-lg hover:bg-gray-100">Back</button>
      <button onClick={onNext} className="bg-blue-600 text-white font-bold py-2 px-4 rounded-lg shadow-md hover:bg-blue-700">Next</button>
    </div>
  </div>
);

export default BudgetStepWrapper;